import { createSelector } from "reselect"
import { get, keyBy, chain, reduce, set } from "lodash"

const EMPTY_ARRAY = []
export const getModelMetadata = state => get(state, "global.data.modelMetadata.data.model")
export const getModelFactors = createSelector(
  [getModelMetadata],
  (modelMetadata) => keyBy(get(modelMetadata, "factors"), "id"),
)

export const getModelCategories = createSelector(
  [getModelMetadata],
  (modelMetadata) => get(modelMetadata, "categories", EMPTY_ARRAY),
)

export const getModelTopFactors = createSelector(
  [getModelMetadata],
  (modelMetadata) => get(modelMetadata, "topFactors", EMPTY_ARRAY),
)

export const getModelDefaultBenchmark = createSelector(
  [getModelMetadata],
  (modelMetadata) => get(modelMetadata, "defaultBenchmark"),
)

export const getModelFactorsClassification = createSelector(
  [getModelMetadata],
  (modelMetadata) => chain(modelMetadata)
    .get("linkedFactors")
    .reduce((allKeyedFactors, { id: factorId, factors }) => ({
      ...allKeyedFactors,
      ...reduce(factors, (keyedFactors, factor) => set(keyedFactors, factor, factorId), {}),
    }), {})
    .value(),
)

export const getModelSupportedCurrencies = createSelector(
  [getModelMetadata],
  (modelMetadata) => chain(modelMetadata)
    .get("supportedCurrencies")
    .reduce((currencies, currency) => ({
      ...currencies,
      [currency]: true,
    }), {})
    .value(),
)
